module.exports = __webpack_public_path__ + "img/landing-02.3f8cce99.png";